import { SEO } from "@/components/SEO";
import { Header } from "@/components/Header";
import { HeroCarousel } from "@/components/HeroCarousel";
import { AuthorityBar } from "@/components/AuthorityBar";
import { TrustBar } from "@/components/TrustBar";
import { CertificateInfo } from "@/components/CertificateInfo";
import { ProductSelector } from "@/components/ProductSelector";
import { Testimonials } from "@/components/Testimonials";
import { Benefits } from "@/components/Benefits";
import { FAQ } from "@/components/FAQ";
import { FinalCTA } from "@/components/FinalCTA";
import { NewsletterCTA } from "@/components/NewsletterCTA";
import { Footer } from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Certificado Digital para CPF e CNPJ com validade ICP-Brasil"
        description="Emita seu certificado digital e-CPF ou e-CNPJ com segurança e agilidade. Atendimento 100% online ou presencial. Parceira da SoluxID (AC ICP-Brasil). Emissão em minutos*."
        canonical="/"
        breadcrumbs={[{ name: "Início", url: "/" }]}
      />
      <Header />
      {/* Flexbox + order classes dão layouts diferentes por breakpoint sem
          duplicar componentes:
          - MOBILE: ProductSelector abre a página (foco em A1/A3), Hero e
            Benefits ficam ocultos.
          - DESKTOP: ordem clássica Hero → Authority → Trust → Info → Selector. */}
      <main className="flex flex-col">
        {/* Intro mobile — título da marca com gradiente e selo ICP-Brasil */}
        <section className="md:hidden order-0 relative overflow-hidden bg-gradient-to-br from-primary via-primary to-secondary text-white">
          <div aria-hidden className="absolute -top-16 -right-10 h-40 w-40 rounded-full bg-white/10 blur-2xl" />
          <div aria-hidden className="absolute -bottom-12 -left-10 h-32 w-32 rounded-full bg-white/5 blur-2xl" />
          <div className="relative container py-8 flex flex-col items-center text-center gap-3">
            <div className="inline-flex items-center gap-1.5 rounded-full bg-white/15 backdrop-blur-sm px-3 py-1 border border-white/20">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="h-3 w-3">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
              <span className="text-[10px] font-bold uppercase tracking-wider">
                ICP-Brasil Autorizado
              </span>
            </div>
            <h1 className="font-extrabold leading-[0.95] tracking-tight">
              <span className="block text-3xl">Certificadora</span>
              <span className="block text-5xl bg-gradient-to-r from-white via-white to-white/70 bg-clip-text text-transparent drop-shadow-sm">
                Digital
              </span>
              <span className="block text-sm font-semibold uppercase tracking-[0.35em] text-white/80 mt-1">
                Mobile
              </span>
            </h1>
            <p className="text-xs text-white/80 max-w-[260px]">
              Escolha seu certificado abaixo e pague em minutos. Sem filas, sem papelada.
            </p>
          </div>
          {/* Curva decorativa no bottom — conecta com a seção de produtos */}
          <svg aria-hidden className="absolute -bottom-px left-0 right-0 w-full h-4 text-muted/50" viewBox="0 0 1440 48" preserveAspectRatio="none">
            <path fill="currentColor" d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" />
          </svg>
        </section>

        <div className="hidden md:block md:order-1">
          <HeroCarousel />
        </div>
        <div className="order-1 md:order-5">
          <ProductSelector />
        </div>
        <div className="order-2 md:order-2">
          <AuthorityBar />
        </div>
        <div className="order-3 md:order-3">
          <TrustBar />
        </div>
        {/* CertificateInfo oculto no mobile — é um segundo módulo de compra
            (tabs PF/PJ/MEI + A1/A3 + CTA) que duplica o ProductSelector.
            Mantém só no desktop como seção educativa. */}
        <div className="hidden md:block md:order-4">
          <CertificateInfo />
        </div>
        {/* Testimonials: só no mobile (depoimentos ficam mais alinhados ao
            fluxo app; no desktop já temos autoridade via TrustBar/Authority) */}
        <div className="order-5 md:hidden">
          <Testimonials />
        </div>
        {/* Benefits removido em todos os breakpoints (pitch "Sou contador"
            está off-brand do fluxo compra). Componente preservado pra uso
            futuro em landing específica de contador. */}
        <div className="order-6 md:order-8">
          <FAQ />
        </div>
        {/* FinalCTA (WhatsApp/Phone/Email + Garantia + Compra Flash) e
            NewsletterCTA ocultos no mobile — o Footer + WhatsApp flutuante
            já cobrem contato, e Newsletter polui o fluxo de compra. */}
        <div className="hidden md:block md:order-9">
          <FinalCTA />
        </div>
        <div className="hidden md:block md:order-10">
          <NewsletterCTA />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
